// KvizWin.jsx
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Kviz from '../block/Kviz';

class KvizWin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    // Блокировка прокрутки body при открытии через props
    if (this.props.show) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      this.setState({ isVisible: this.props.show });
      // Блокировка/разблокировка прокрутки при изменении состояния
      document.body.style.overflow = this.props.show ? 'hidden' : 'unset';
    }
  }

  componentWillUnmount() {
    // Возвращаем прокрутку при размонтировании
    document.body.style.overflow = 'unset';
  }

  handleClose = () => {
    this.setState({ isVisible: false });
    document.body.style.overflow = 'unset';
    if (this.props.hideFn) {
      this.props.hideFn();
    }
  };

  handleOpen = () => {
    this.setState({ isVisible: true });
    document.body.style.overflow = 'hidden';
    if (this.props.showFn) {
      this.props.showFn();
    }
  };

  render() {
    const { data } = this.props;
    const { isVisible } = this.state;

    return (
      <>
        {/* Кнопка вызова квиза - скрыта на мобильных */}
        <button
          onClick={this.handleOpen}
          className="fixed left-0 bg-[#009ee3] top-1/2 -translate-y-1/2 z-40 py-3 px-2 rounded-r-xl font-semibold text-white transition-all duration-300 cursor-pointer border-none shadow-lg hover:opacity-90 writing-vertical-rl text-orientation-mixed tracking-wider text-xs sm:text-sm hidden lg:block"
          aria-label="Запросить коммерческое предложение"
        >
          Запросить КП
        </button>

        {/* Модальное окно - только рендерится когда открыто */}
        {isVisible && (
          <>
            {/* Затемнение (оверлей) */}
            <div
              className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 transition-opacity duration-300"
              onClick={this.handleClose}
              role="presentation"
            />

            {/* Окно квиза - на мобильных весь экран, на десктопе центрировано */}
            <div
              className="fixed inset-0 z-50 flex items-center lg:justify-center p-0 lg:p-4 pointer-events-none"
              role="dialog"
              aria-modal="true"
            >
              <div className="relative pointer-events-auto w-full h-full lg:h-auto lg:w-full lg:max-w-2xl lg:max-h-[90vh] lg:rounded-2xl shadow-2xl animate-modalShow flex flex-col bg-white lg:bg-transparent">
                {/* Кнопка закрытия */}
                <button
                  onClick={this.handleClose}
                  className="absolute top-3 right-3 lg:-top-3 lg:-right-3 z-10 w-8 h-8 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-gray-100 transition-colors flex-shrink-0"
                  aria-label="Закрыть"
                  type="button"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L13 13" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M13 1L1 13" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>

                {/* Содержимое квиза с прокруткой - на мобильных на всю высоту */}
                <div className="flex-1 overflow-y-auto lg:max-h-[90vh] lg:rounded-2xl">
                  <Kviz data={data} hideFn={this.handleClose} />
                </div>
              </div>
            </div>
          </>
        )}

        <Helmet>
          <style>{`
          @keyframes modalShow {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          .animate-modalShow {
            animation: modalShow 0.3s ease-out;
          }

          .writing-vertical-rl {
            writing-mode: vertical-rl;
          }

          .text-orientation-mixed {
            text-orientation: mixed;
          }

          .tracking-wider {
            letter-spacing: 0.05em;
          }
        `}</style>
        </Helmet>
      </>
    );
  }
}

export default KvizWin;